function DashboardActiveFlagAndRoad( {value} ) {
    var flag = value["is-chequered-flag"] === 1 ? 5 : value["is-green-flag"] === 1 ? 7 : value["is-red-flag"] === 1 ? 6 : value["is-white-flag"] === 1 ? 4 : 0;

    const flagText = {
        1: "Blue",
        2: "Yellow",
        3: "Disqualified",
        4: "Last Lap",
        5: "Finish",
        6: "Red",
        7: "Track Clear",
        8: "Repair Damage"
    }[flag] || "No Flag";

    const flagIconColor = {
        1: "material-symbols-outlined text-acc-blue",
        2: "material-symbols-outlined text-acc-yellow",
        3: "material-symbols-outlined text-acc-black",
        4: "material-symbols-outlined text-acc-black",
        5: "material-symbols-outlined text-acc-white blend-difference",
        6: "material-symbols-outlined text-acc-red",
        7: "material-symbols-outlined text-acc-green",
        8: "material-symbols-outlined text-acc-orange"
    }[flag] || "material-symbols-outlined text-acc-white";

    const flagTextColor = {
        1: "text-sm font-bold text-acc-blue uppercase tracking-widest",
        2: "text-sm font-bold text-acc-yellow uppercase tracking-widest",
        3: "text-sm font-bold text-acc-black uppercase tracking-widest",
        4: "text-sm font-bold text-acc-black uppercase tracking-widest",
        5: "text-sm font-bold text-acc-white uppercase tracking-widest blend-difference",
        6: "text-sm font-bold text-acc-red uppercase tracking-widest",
        7: "text-sm font-bold text-acc-green uppercase tracking-widest",
        8: "text-sm font-bold text-acc-orange uppercase tracking-widest mix-blend-difference"
    }[flag] || "text-sm font-bold text-acc-white uppercase tracking-widest";

    const flagBgColor = {
        1: "flex h-10 items-center gap-2 rounded bg-acc-blue/20 px-4 border border-acc-blue/30",
        2: "flex h-10 items-center gap-2 rounded bg-acc-yellow/20 px-4 border border-acc-yellow/30",
        3: "flex h-10 items-center gap-2 rounded bg-acc-black/20 px-4 border border-acc-black/30",
        4: "flex h-10 items-center gap-2 rounded bg-acc-white/70 px-4 border border-acc-white/30",
        5: "flex h-10 items-center gap-2 rounded bg-acc-black/20 px-4 border border-acc-black/30 bg-[repeating-conic-gradient(#808080_0_25%,#0000_0_50%)] bg-[50%/10px_10px]",
        6: "flex h-10 items-center gap-2 rounded bg-acc-red/20 px-4 border border-acc-red/30",
        7: "flex h-10 items-center gap-2 rounded bg-acc-green/20 px-4 border border-acc-green/30",
        8: "flex h-10 items-center gap-2 rounded bg-[radial-gradient(circle,rgba(255,162,0,1)_50%,rgba(0,0,0,1)_50%)] px-4 border border-acc-orange/30"
    }[flag] || "flex h-10 items-center gap-2 rounded bg-acc-black/20 px-4 border border-acc-white/30";

    return (
        <div className="flex flex-row items-center gap-2">
            <div className={flagBgColor}>
                <span className={flagIconColor}>flag</span>
                <span className={flagTextColor}>{flagText}</span>
            </div>

            <div className="flex h-10 items-center gap-3 rounded bg-[#233648]/50 px-3">
                <span className="material-symbols-outlined text-sm text-[#92adc9]">thermostat</span>
                <div className="flex gap-3">
                    <div className="flex flex-col">
                        <span className="text-[9px] text-[#92adc9] uppercase">Air</span>
                        <span className="text-xs font-bold">{Math.round(value["road-data:air-temp"])}°C</span>
                    </div>

                    <div className="flex flex-col">
                        <span className="text-[9px] text-[#92adc9] uppercase">Track</span>
                        <span className="text-xs font-bold">{Math.round(value["road-data:road-temp"])}°C</span>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default DashboardActiveFlagAndRoad;